/**
 * True only for an absolute https: URL. Used to gate user-supplied hrefs at
 * render time (profile social links, Security audit 1219257699456713 item 15):
 * the save path already enforces https://, but a stored value must not reach
 * an anchor on the strength of that alone.
 */
export const isHttpsUrl = (url: string | null | undefined): boolean => {
  if (!url) return false;
  try {
    return new URL(url).protocol === 'https:';
  } catch {
    return false;
  }
};

export default isHttpsUrl;
